module.exports = __webpack_public_path__ + "img/login_logo_predixon.e90fae16.png";